export default __webpack_public_path__ + "static/tum-cfb02569522cfbd913b78e4c1f3a16df.png";